// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --ease-in-out-animation-duration:300ms;
  --ease-in-out-animation-timing-function:cubic-bezier(0.35, 0, 0.25, 1);
  --fast-animation-duration:150ms;
  --slower-animation-duration:500ms;
  --ease-animation:200ms ease;
}
:root{
  --cardListHeaderMinHeight:4rem;
}
:root{
  --footerMargin:6rem;
}
:root{
  --overlaySoftLightZIndex:50;
  --overlayGreyZIndex:95;
}
:root{
  --checkboxSize:1.125rem;
  --inputLineColor:var(--colorGreyLight);
  --inputLabelColor:var(--colorGreyLight);
  --inputIconWidth:1.875rem;
  --inputBorderWidth:2px;
  --selectHeight:3rem;
}
:root{
  --sliderTitleZIndex:2;
  --playerErrorZIndex:8;
  --overlaySoftLightZIndex:50;
  --playerTopOfRecordingsPageZIndex:90;
  --fixedHeaderZIndex:91;
  --overlayGreyZIndex:95;
  --sideNavZIndex:96;
  --playerVisualizationWarningZIndex:99;
  --searchResultsOverlayZIndex:100;
  --searchInputValidationTextZIndex:101;
  --playbackRateControlZIndex:101;
  --modalZIndex:102;
  --dropdownMenuZIndex:110;
  --searchHintZIndex:150;
}
ftr-link-grid-item{
  margin-bottom:2rem;
}
.link-grid-item{
  display:flex;
  flex-direction:column;
  height:100%;
  background-color:#fff;
  border:0.0625rem solid #d4d4d4;
  border-radius:0.25rem;
}
.link-grid-item__links{
    padding-top:1rem;
    margin-right:-1rem;
    margin-left:-1rem;
  }
.link-grid-item__links a{
      display:block;
      padding:1rem;
      transition:background-color 150ms;
    }
.link-grid-item__links a:hover{
        background-color:#f6f7f8;
      }
.link-grid-item__content{
    padding:1rem;
  }
.link-grid-item__header{
    display:flex;
    flex-direction:row;
    align-items:center;
    padding:1rem;
    background-color:#d4d4d4;
    border-bottom:0.0625rem solid #d4d4d4;
  }
.link-grid-item__header > h3{
      flex-grow:1;
      padding:0;
      margin:0;
      overflow:hidden;
      text-overflow:ellipsis;
      text-transform:uppercase;
      white-space:nowrap;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
